/**
 * The section a detail page belongs to, for the mobile top bar.
 *
 * That bar held a sidebar trigger and nothing else, so on a phone every page
 * carried 56 pixels of empty rule above it and the only way up from a member's
 * profile was the hamburger. Todd's note was "I'd get in a dead end and have to
 * open the menu".
 *
 * The parent only, never the page you are on. He suggested "Directory >
 * Amanda", but Amanda's name is already the largest thing on the screen
 * directly below this; the half that is missing is the way back to the list.
 *
 * Read off the path rather than published by each page, so a page that gains a
 * detail route gets this by adding a line here instead of wiring a context
 * through the layout.
 */
export type ParentSection = { label: string; to: string };

const PARENTS: [RegExp, ParentSection][] = [
  [/^\/directory\/[^/]+$/, { label: "Directory", to: "/directory" }],
  // A legacy is found in the directory, under its Legacies tab.
  [/^\/organizations\/[^/]+$/, { label: "Directory", to: "/directory" }],
  [/^\/discussions\/[^/]+$/, { label: "Discussion", to: "/discussions" }],
  [/^\/help\/[^/]+$/, { label: "Help", to: "/help" }],
];

/** Null at the top level, where the sidebar is already the way around. */
export function parentSection(pathname: string): ParentSection | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  for (const [pattern, parent] of PARENTS) {
    if (pattern.test(path)) return parent;
  }
  return null;
}
